import React from 'react';
import ReactDOM from 'react-dom/client';
import { ColorSchemeScript } from '@mantine/core';
import { App, COLOR_SCHEME_STORAGE_KEY } from './App';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <ColorSchemeScript
      defaultColorScheme="auto"
      localStorageKey={COLOR_SCHEME_STORAGE_KEY}
    />
    <App />
  </React.StrictMode>,
);
